import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useDashboardSidebarItems } from "../../hooks/useDashboardSidebarItems";
import { NavBarVertical } from "../layout/nav";
import TopNavbar from "./TopNavbar";
import { HeaderActionsProvider } from "./HeaderActions";
import { BreadcrumbTitleProvider } from "./BreadcrumbTitle";

export default function V2DashboardLayout() {
  const { sidebarItems, bottomSidebarItems, footerSidebarItems } =
    useDashboardSidebarItems({
      excludeOnboardingSidebar: true,
    });

  return (
    <HeaderActionsProvider>
      <BreadcrumbTitleProvider>
        <Box
          sx={{
            display: "flex",
            height: "100vh",
            overflow: "hidden",
            bgcolor: "#FFFFFF",
          }}
        >
          <NavBarVertical
            sidebarItems={sidebarItems}
            bottomSidebarItems={bottomSidebarItems}
            footerSidebarItems={footerSidebarItems}
          />
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <TopNavbar />
            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
              }}
            >
              <Outlet />
            </Box>
          </Box>
        </Box>
      </BreadcrumbTitleProvider>
    </HeaderActionsProvider>
  );
}
